export enum Layout {
  Users = 'users',
  Admins = 'admins'
}
